import React, { useRef } from "react";
import { FeatureGroup } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import { saveAs } from "file-saver";


const GeoJsonHandler = ({ onGeoJsonChange }) => {
  const featureGroupRef = useRef(null);

  const handleExport = () => {
    if (featureGroupRef.current) {
      const geoJsonData = featureGroupRef.current.toGeoJSON();
      const blob = new Blob([JSON.stringify(geoJsonData)], { type: "application/json" });
      saveAs(blob, "survey-data.geojson");
    }
  };

  const handleImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = JSON.parse(e.target.result);
      if (onGeoJsonChange) onGeoJsonChange(data);
    };
    reader.readAsText(file);
  };

  return (
    <div style={{ position: "absolute", top: 10, left: 10, zIndex: 1000 }}>
      <button onClick={handleExport}>Export GeoJSON</button>
      <input type="file" accept=".geojson" onChange={handleImport} />
      <FeatureGroup ref={featureGroupRef}>
        <EditControl position="topright" draw={{ rectangle: true, circle: false }} />
      </FeatureGroup>
    </div>
  );
};

export default GeoJsonHandler;
